import React from 'react';
import cn from '@/utils/cn';
import styles from '../../Navigator.module.scss';
import LockedSlideIcon from './LockedSlideIcon';
import useSlideConditions from '../../../useSlideConditions';
import { ISlideOrSlideGroup } from '@/components/admin/SlideShow/stores/useSlideShowStore';

interface NavigationButtonProps {
  disabled: boolean;
  faIcon: 'fa-chevron-left' | 'fa-chevron-right';
  label: 'Next Slide' | 'Previous Slide';
  sessionLocked?: boolean;
  slide: ISlideOrSlideGroup;
  onClick: () => void;
}

const NavigationButton = ({ disabled, faIcon, label, onClick, sessionLocked, slide }: NavigationButtonProps) => {
  const { isSlideLocked } = useSlideConditions();

  if (!sessionLocked && isSlideLocked(slide)) {
    return (
      <span className={styles.navigatorButton}>
        <LockedSlideIcon slide={slide} />
      </span>
    );
  }

  return (
    <button
      aria-disabled={disabled}
      aria-label={label}
      className={cn(styles.navigatorButton, { [styles.sessionLocked]: sessionLocked })}
      disabled={disabled}
      type="button"
      onClick={onClick}
    >
      <span aria-hidden="true" className={`fa ${faIcon}`} />
    </button>
  );
};

export default NavigationButton;
